import {
  AnalyticsEvent,
  TileStatus,
  TileType,
  TopPerksTile,
  TopPickPartnerOffer,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import {
  AvatarCardProps,
  AvatarWithLabelProps,
} from 'shared/components/vxl/AvatarCard/AvatarCard';
import { VXLComponent, VXLComponentId } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

interface TopPerksTileNode extends VXLComponent {
  id: string;
  name: VXLComponentId.AVATAR_CARD;
  props: AvatarCardProps;
}

const topPerksTile = (
  tile: TopPerksTile,
  dependencies: HomeCardDependencies,
): Maybe<TopPerksTileNode> => {
  const { id, topPicks } = tile;
  const { goToTopPerks, viewRewardDetails, translatedText } = dependencies;

  if (
    tile.status !== TileStatus.Loaded ||
    tile.tileType !== TileType.TopPerks ||
    !topPicks ||
    !topPicks.length
  ) {
    return null;
  }

  const getTopPerksTiles = (
    topPicks: TopPickPartnerOffer[],
  ): AvatarWithLabelProps[] => {
    return topPicks.map((data: TopPickPartnerOffer) => ({
      labelText: data.cashbackAmount ?? '',
      onPress: () => {
        const analyticEvent = data.clickAnalytics as AnalyticsEvent;
        viewRewardDetails(data.id, analyticEvent);
      },
      avatarProps: {
        id: data.id,
        name: VXLComponentId.ICON_AVATAR,
        props: {
          imageSource: {
            uri: data.logoImage,
          },

          variant: 'MD',
        },
      },
    }));
  };

  return {
    id: id,
    name: VXLComponentId.AVATAR_CARD,
    props: {
      titleText: translatedText('topPerk.title'),
      avatarData: getTopPerksTiles(topPicks ?? []),
      isDisabled: false,
      titlePressAction: () => {
        goToTopPerks();
      },
      analyticsId: 'allRewardPressed',
    },
  };
};

export default topPerksTile;
